export default {
      id: "map__car_type_reefer-usage",
      viewBox: "0 0 15 35",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_reefer",
      toString: function () {
        return this.url;
      }
    }